module.exports = __webpack_public_path__ + "static/media/servicios-banner.5c49cede.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/servicios/servicios-banner.png
// module id = 166
// module chunks = 0